import markConversationsReadInListViewStore from '../actions/triage/markConversationsReadInListViewStore';
import markItemsReadInListViewStore from '../actions/triage/markItemsReadInListViewStore';
import { actionNames, MarkAllAsReadStoreUpdate } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { getRowIdsFromRowKeys, TableView } from 'owa-mail-list-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default function markAllAsReadStitch() {
    subscribe<MarkAllAsReadStoreUpdate>(
        actionNames.MarkAllAsReadStoreUpdate,
        (tableView: TableView, markAsRead: boolean) => {
            // Table may not exist if user is clicking on context menu option for an unselected folder
            if (!tableView) {
                return;
            }

            switch (tableView.tableQuery.listViewType) {
                case ReactListViewType.Conversation:
                    markConversationsReadInListViewStore(
                        tableView.rowKeys,
                        markAsRead,
                        tableView,
                        false /* updateFolderCounts */
                    );
                    break;

                case ReactListViewType.Message:
                    const itemIdStrings = getRowIdsFromRowKeys(tableView.rowKeys, tableView.id);
                    markItemsReadInListViewStore(tableView, itemIdStrings, markAsRead);
                    break;
            }
        }
    );
}
